<template>
  <div class="order-forQy">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-button
        v-if="canEdit"
        type="success"
        :disabled="saving"
        style="position: fixed; right: 100px; z-index: 99"
        @click="zdph()"
      >整单配货</el-button>
      <el-button
        style="background: cornflowerblue; color: white;position: fixed; right: 20px; z-index: 99"
        :loading="printing"
        @click="print"
      >打印<span v-if="printing">中...</span></el-button>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="订单信息" name="first">
          <!-- <el-scrollbar> -->
          <el-table
            v-el-table-height-fix
            height="100%"
            :data="form.entrys"
            :row-class-name="rowClassName"
            row-key="fEntryID"
          >
            <el-table-column width="150px">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  @click="select(scope.row)"
                >查看明细</el-button>

                <!-- <el-button
                    type="warning"
                    :disabled="saving"
                    size="small"
                    @click="ph(scope.row)"
                    >配货</el-button
                  > -->
              </template>
            </el-table-column>
            <el-table-column label="产品编号" prop="fNumber" />
            <el-table-column label="产品名称" prop="fName" />
            <el-table-column label="规格" prop="fModel" />
            <el-table-column label="单位" prop="fUnit" />
            <el-table-column label="送货单单价" prop="fPrice_fh" />
            <el-table-column label="订单数量" prop="fQty" />
            <el-table-column label="已配货数量" prop="fQty_ph" />
            <el-table-column label="未配货数量" prop="fQty_wph" />
            <el-table-column label="生产批号" min-width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.fBatchNo">
                  <span v-for="(item,index) in scope.row.fBatchNo" :key="item.id" style="display: flex">
                    <span v-if="index==scope.row.fBatchNo.length-1" style="display: flex;align-items: center;flex: 1">{{ item }}</span>
                    <span v-else style="display: flex;align-items: center;flex: 1">{{ item }};</span>               </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="生产日期" min-width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.fDate_Sc">
                  <span v-for="(item,index) in scope.row.fDate_Sc" :key="item.id" style="display: flex">
                    <span v-if="index==scope.row.fDate_Sc.length-1" style="display: flex;align-items: center;flex: 1">{{ item }}</span>
                    <span v-else style="display: flex;align-items: center;flex: 1">{{ item }};</span>
                  </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="消毒日期" min-width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.fDate_Xd">
                  <span v-for="(item,index) in scope.row.fDate_Xd" :key="item.id" style="display: flex">
                    <span v-if="index==scope.row.fDate_Xd.length-1" style="display: flex;align-items: center;flex: 1">{{ item }}</span>
                    <span v-else style="display: flex;align-items: center;flex: 1">{{ item }};</span>                    </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="发货日期" min-width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.fDate_fh">
                  <span v-for="(item,index) in scope.row.fDate_fh" :key="item.id" style="display: flex">
                    <span v-if="index==scope.row.fDate_fh.length-1" style="display: flex;align-items: center;flex: 1">{{ item }}</span>
                    <span v-else style="display: flex;align-items: center;flex: 1">{{ item }};</span>                    </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="追溯号" min-width="120">
              <template slot-scope="scope">
                <template v-if="scope.row.fRetroactiveNo">
                  <span v-for="(item,index) in scope.row.fRetroactiveNo" :key="item.id" style="display: flex">
                    <span v-if="index==scope.row.fRetroactiveNo.length-1" style="display: flex;align-items: center;flex: 1">{{ item }}</span>
                    <span v-else style="display: flex;align-items: center;flex: 1">{{ item }};</span>                    </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="fDes" />
          </el-table>
          <!-- </el-scrollbar> -->
        </el-tab-pane>
        <el-tab-pane v-if="canEdit" label="确认" name="second">
          <el-form label-width="78px" style="overflow: auto">
            <el-form-item
              label="意见"
              style="margin-top: 10px"
              class="formitem"
            >
              <el-input
                v-model="form.procedureInfo.fOpinion"
                type="textarea"
                rows="4"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :disabled="saving"
                @click="submit(1)"
              >通过</el-button>
              <el-button
                type="warning"
                :disabled="saving"
                @click="submit(2)"
              >回退</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <el-dialog
      title="明细"
      :visible.sync="outerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="85%"
    >
      <el-dialog
        width="70%"
        title="配货"
        :visible.sync="innerVisible"
        append-to-body
        :destroy-on-close="true"
      >
        <Inventorys
          v-model="selInventorys"
          :f-entry-i-d="curEditItem.fEntryID"
          :visible="innerVisible"
        />
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">关闭</el-button>
          <el-button
            type="primary"
            :disabled="!selInventorys.length || saving"
            @click="select3"
          >选择</el-button>
        </div>
      </el-dialog>

      <el-form
        v-loading="loading2"
        class="detialForm"
        inline
        label-width="100px"
      >
        <!-- {{curEditItem}} -->
        <div style="display: flex; flex-direction: row">
          <el-form-item label="编号：">
            <span style="color: #000; font-weight: 800">{{
              curEditItem.fNumber
            }}</span>
          </el-form-item>
          <el-form-item label="品名：">
            <span style="color: #000; font-weight: 800">{{
              curEditItem.fName
            }}</span>
          </el-form-item>
          <el-form-item label="仓库：">
            <span style="color: #000; font-weight: 800">{{
              curEditItem.fStock
            }}</span>
          </el-form-item>
          <el-form-item label="数量：">
            <span style="color: #000; font-weight: 800">{{
              curEditItem.fQty
            }}</span>
          </el-form-item>
        </div>
        <div style="display: flex; flex-direction: row">
          <el-form-item label="发货日期">
            <el-date-picker
              v-model="curEditItem.fDate_fh"
              type="date"
              disabled
              value-format="yyyy-MM-dd"
              style="width: 200px"
            />
          </el-form-item>

          <el-form-item label="送货单单价">
            <el-input-currency
              v-model="curEditItem.fPrice_fh"
              :scale="2"
              disabled
              style="width: 200px"
            />
          </el-form-item>
          <!-- <el-form-item label="备选追溯号">
            <el-input v-model="curEditItem.ffRetroactiveNo_by" />
          </el-form-item> -->
          <el-form-item label="备注">
            <el-input
              v-model="curEditItem.fDes"
              style="width: 500px"
              disabled
            />
          </el-form-item>
        </div>

        <div style="margin-left: 100px">
          <!-- <el-button size="small" type="warning" @click="select2"
            >添加</el-button
          > -->
        </div>

        <el-table :data="curEditItem.entrys">
          <el-table-column
            label="库存日期"
            prop="fDate"
            width="100"
            :formatter="dateFormat"
          />
          <el-table-column label="生产批号" prop="fBatchNo" />
          <el-table-column
            label="生产日期"
            prop="fDate_Sc"
            :formatter="dateFormat"
            width="100"
          />
          <el-table-column
            label="消毒日期"
            prop="fDate_Xd"
            :formatter="dateFormat"
            width="100"
          />
          <el-table-column label="追溯号" prop="fRetroactiveNo" />
          <el-table-column
            label="追溯号2"
            width="300"
          ><template slot-scope="scope">
            <el-input
              v-model="scope.row.fRetroactiveNo2"
              disabled
              style="width: 100%"
            />
          </template>
          </el-table-column>
          <el-table-column label="即时库存数" prop="fQty" />
          <el-table-column label="锁库数" prop="fLockQty" />
          <el-table-column label="其它订单配货数" prop="fOtherPhQty" />
          <el-table-column label="可用库存数" prop="fKyQty" />
          <el-table-column label="配货数" width="150">
            <template slot-scope="scope">
              <el-input-currency
                v-model="scope.row.fPhQty"
                :scale="0"
                style="width: 100%"
                disabled
              />
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">关闭</el-button>
        <el-button
          v-if="false"
          type="primary"
          :disabled="saving"
          @click="save()"
        >保存</el-button>
      </div>
    </el-dialog>
    <iframe
      style="display: none"
    ><Print id="printVoucher1" ref="printVoucher1"></Print
      ></iframe>
    <iframe
      style="display: none"
    ><Print2 id="printVoucher2" ref="printVoucher2"></Print2
      ></iframe>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import Inventorys from './Inventorys'
import ReturnNode from '@components/ReturnNode'
import Print from '../commonPrint/Print.vue'
import Print2 from '../commonPrint/Index.vue'
import printnb from '@plugins/vue-print-nb-printarea'

export default {
  components: {
    Inventorys, Print, Print2
  },
  data: function() {
    return {
      form: {
        procedureInfo: {},
        entrys: []
      },
      printing: false,
      rules: {},

      activeName: 'first',

      curEditItem: {
        entrys: []
      },

      saving: false,
      loading: false,
      loading2: false,
      isNew: false,

      outerVisible: false,
      innerVisible: false,
      selInventorys: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canEdit: function() {
      return false
    }
  },
  methods: {
    rowClassName: function({ row, rowIndex }) {
      return row.fQty_wph > 0 ? 'warning-row' : null
    },

    select: async function(row) {
      this.outerVisible = true
      this.loading2 = true
      var res = await this.$httpPost(
        'OrderManage/OrderForCcbc/GetOrderForPhInfo',
        { fid: row.fEntryID }
      ).finally((x) => (this.loading2 = false))
      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }
      this.curEditItem = res.datalist
    },

    select2: function() {
      this.selInventorys = []
      this.innerVisible = true
    },

    select3: function() {
      var selItems = this.selInventorys
      var entrys = this.curEditItem.entrys

      for (let j = 0; j < selItems.length; j++) {
        const item = selItems[j]
        // if (!item.fPhQty) continue
        var found = false
        for (let i = 0; i < entrys.length; i++) {
          const entry = entrys[i]
          if (entry.fInventoryID == item.fInventoryID) {
            var num = entry.fPhQty || 0
            num += item.fPhQty
            entry.fPhQty = num
            found = true
            break
          }
        }
        if (!found) {
          entrys.push(item)
        }
      }
      this.innerVisible = false
    },

    zdph: async function(slient, confirm) {
      if (!slient) {
        var flg = await this.$ask(`是否进行整单配货?`)
        if (!flg) return
      }
      this.saving = true
      var res = await this.$httpPost('OrderManage/OrderForCcbc/OrderForPh', {
        fid: this.form.fid,
        confirm: confirm || 'F'
      }).finally((x) => (this.saving = false))
      if (res.isSuccess) {
        this.$message.success(res.message)
        this.refresh()
      } else {
        if (res.returnCode == '00006') {
          var flg = await this.$ask(res.message)
          if (flg) {
            this.zdph(true, 'T')
          }
        } else {
          this.$message.error(res.message)
        }
      }
    },
    ph: async function(row, slient, confirm) {
      if (!slient) {
        var flg = await this.$ask(`是否对'${row.fName}'进行配货?`)
        if (!flg) return
      }
      this.saving = true
      var res = await this.$httpPost('OrderManage/OrderForCcbc/OrderForPhmx', {
        fid: row.fEntryID,
        confirm: confirm || 'F'
      }).finally((x) => (this.saving = false))
      if (res.isSuccess) {
        this.$message.success(res.message)
        this.refresh()
      } else {
        if (res.returnCode == '00006') {
          var flg = await this.$ask(res.message)
          if (flg) {
            this.ph(row, true, 'T')
          }
        } else {
          this.$message.error(res.message)
        }
      }
    },

    save: async function() {
      this.saving = true
      var res = await this.$httpPost(
        'OrderManage/OrderForCcbc/OrderForPhInfoSave',
        {
          datalist: JSON.stringify(this.curEditItem)
        }
      ).finally((x) => (this.saving = false))

      if (res.isSuccess) {
        this.$message.success(res.message)
        this.outerVisible = false
        this.refresh()
      } else {
        if (res.returnCode == '00006') {
          var flg = await this.$ask(res.message)
          if (flg) {
            this.curEditItem.confirm = 'T'
            this.save()
          }
        } else {
          this.$message.error(res.message)
        }
      }
    },
    print: async function() {
      // this.$router.push({ path: '/orderManage/commonPrint' })
      this.printing = true
      let printversion
      let success
      console.log(this.form, 'form')

      const fControlledNumber = this.form.fControlledNumber
      // 旧的打印模块
      if (
        fControlledNumber == 'SS-FOR-08-04B' ||
        fControlledNumber == 'WYJK-QPR-04-01A'
      ) {
        printversion = 'printVoucher2'
        success = await this.$refs.printVoucher2.refresh(this.form.fid)
      } else {
        // 新的打印模块
        printversion = 'printVoucher1'
        success = await this.$refs.printVoucher1.refresh(this.form.fid)
      }
      if (!success) {
        this.printing = false
        return
      }
      // https://www.npmjs.com/package/vue-print-nb
      new printnb({
        ids: printversion, // * 局部打印必传入id
        standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: '', // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: '', // 额外的css连接，多个逗号分开
        popTitle: '', // title的标题
        endCallback() {
          // 调用打印之后的回调事件
        }
      })
      setTimeout(() => {
        this.printing = false
      }, 100)
    },
    submit: function(type) {
      this.$refs.form.validate(async(valid) => {
        this.form.procedureInfo.fType = type
        if (type == 2) {
          if (!this.form.procedureInfo.fOpinion) {
            this.activeName = 'second'
            this.$message.error('请填写审核意见')
            return
          }

          const h = this.$createElement
          this.form.procedureInfo.returnNode = await new Promise(
            (resolve, reject) => {
              this.$formDlg({
                title: '选择回退节点',
                formTpl: <ReturnNode name={'Order_ccbc'}></ReturnNode>,
                formSubmit: resolve,
                width: '30%'
              })
            }
          )
        } else {
          this.form.procedureInfo.returnNode = null
          const flg = await this.$ask('是否提交?')
          if (!flg) return
        }

        this.saving = true
        this.$httpPost('OrderManage/OrderForCcbc/OrderForCcbcApproval', {
          datalist: JSON.stringify(this.form)
        })
          .then((res) => {
            if (!res.isSuccess) {
              this.$message.error(res.message)
              return
            }

            // 重新刷新页面数据
            this.$message.success(res.message)
            if (res.datalist) this.refresh(res.datalist)
          })
          .finally(() => (this.saving = false))
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          procedureInfo: {},
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost(
        'OrderManage/OrderForCcbc/GetOrderForCcbc',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      this.form.entrys.forEach(val => {
        // console.log(val, 'val')
        val.fDate_Sc = val.fDate_Sc.split(';')
        val.fBatchNo = val.fBatchNo.split(';')
        val.fDate_Xd = val.fDate_Xd.split(';')
        val.fDate_fh = val.fDate_fh.split(';')
        val.fRetroactiveNo = val.fRetroactiveNo.split(';')
      })
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less">
.order-forQy {
  .el-table .warning-row {
    background: oldlace;
  }

  .detialForm {
    .el-input {
      width: 40%;
    }
  }
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
